var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropdownIndicatorOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 41.054,
    height: 41.054,
    viewBox: "0 0 41.054 41.054",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2781",
    "data-name": "Rectangle 2781",
    width: 41.054,
    height: 41.054,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4017",
    "data-name": "Group 4017",
    transform: "translate(41.054) rotate(90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4004",
    "data-name": "Group 4004",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7371",
    "data-name": "Path 7371",
    d: "M41.054,20.527A20.527,20.527,0,1,1,20.527,0,20.527,20.527,0,0,1,41.054,20.527",
    fill: "#e67964"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7372",
    "data-name": "Path 7372",
    d: "M23.295,18.234,11.547,23.582V21.018l9.086-3.883v-.048L11.547,13.2V10.614l11.748,5.372Z",
    transform: "translate(4.106 3.429)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownIndicatorOpen);
export default __webpack_public_path__ + "static/media/dropdownIndicatorOpen.8ee63e38b250ef084bbdad458138f71b.svg";
export { ForwardRef as ReactComponent };